<label mat-dialog-title class="text-center">
  <span class="uk-text-title">Seleccione los campos que deseé visualizar</span>
</label>
<mat-dialog-content>
  <table
    mat-table
    #table
    [dataSource]="listColumns"
    cdkDropList
    [cdkDropListData]="listColumns"
    (cdkDropListDropped)="dropTable($event)"
  >
    <ng-container matColumnDef="visible">
      <th mat-header-cell *matHeaderCellDef="let element" [ngClass]="'center'">
        Visible
      </th>
      <td
        mat-cell
        *matCellDef="let element; let idx = dataIndex"
        [ngClass]="'center'"
      >
        <mat-checkbox
          [(ngModel)]="element.visible"
          [disabled]="element.mandatory"
        ></mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef="let element">Columna</th>
      <td mat-cell *matCellDef="let element">{{ element.title }}</td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef="let element" [ngClass]="'center'">
        Ordenar
      </th>
      <td
        mat-cell
        *matCellDef="let element"
        class="drag-handle-cell"
        cdkDragHandle
      >
        <mat-icon>drag_indicator</mat-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      cdkDrag
      [cdkDragData]="row"
    ></tr>
  </table>
</mat-dialog-content>
<mat-dialog-actions class="card-button" align="center">
  <button
    matButton="outlined"
    mat-flat-button
    id="closeAlterColumnsModal"
    class="border-box b-s"
    (click)="onCloseClick()"
  >
    Cancelar
  </button>
  <button
    mat-flat-button
    id="applyDataTableAlterColumns"
    cdkFocusInitial
    class="button-success"
    (click)="close()"
  >
    Aplicar
  </button>
</mat-dialog-actions>
<button
  id="closeAlterColumnsDialog"
  mat-button
  mat-dialog-close
  class="dialog-close"
>
  <mat-icon>close</mat-icon>
</button>
